import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '../../BaseComponents/Image'
import CaptionFont from '../../Theme/Fonts/Caption'
import Label10Font from '../../Theme/Fonts/Label10'
import { ProfileProps } from '..'

const RightOptionalProfileField: FC<ProfileProps['rightOptionalFieldProps']> = ({
    imageUrl,
    value,
    metric,
}) => (
    <>
        <Grid noExpand centerHorizontal>
            <Grid noExpand elevation={2}>
                <Image size="M" width={20} imageUrl={imageUrl} />
            </Grid>
        </Grid>
        {value ? (
            <CaptionFont
                lineHeight="12px"
                bold
                paddingTop={2}
                numberOfLines={1}
                textAlign="center"
                color="onyx-5"
            >
                {value}
            </CaptionFont>
        ) : null}
        {metric ? (
            <Label10Font lineHeight="10px" numberOfLines={1} textAlign="center" color="onyx-5">
                {metric}
            </Label10Font>
        ) : null}
    </>
)

export default RightOptionalProfileField
